import { readDataFromLocalStorage } from "../../utils/globalUtils";

export const emptyNote = (docID, baseID) => {
  const author = readDataFromLocalStorage("revvsalesUser");
  const note = {
    content: {},
    object_type: "CONTRACT",
    object_id: parseInt(docID, 10),
    comment_status: "OPEN",
    base_comment_id: baseID || null,
    author: {
      user_email: author ? author.user_email : "",
      id: author ? author.id : 0,
    },
    type: "SIMPLE",
    anchor: {},
    attachments: [],
    id: null,
    replies: [],
  };
  return note;
};

export const findCommentIndex = (noteList, commentID) => {
  const commentIndex = noteList.findIndex(
    noteThread =>
      noteThread.anchor !== undefined &&
      noteThread.anchor.component !== undefined &&
      noteThread.anchor.action !== undefined &&
      noteThread.anchor.component === "DOCUMENT" &&
      noteThread.anchor.action === "COMMENT" &&
      noteThread.content !== undefined &&
      noteThread.anchor.id !== undefined &&
      noteThread.anchor.id === commentID,
  );
  return commentIndex;
};

export const isNewNoteOpen = notes => {
  let isOpen = false;
  notes.forEach(note => {
    if (note.id === null) {
      isOpen = true;
    }
    const { replies } = note;
    if (replies) {
      replies.forEach(reply => {
        if (reply.id === null) {
          isOpen = true;
        }
      });
    }
  });
  return isOpen;
};



// WEBPACK FOOTER //
// ./src/components/Notes/utils.js